import { render } from "./Prizes.vue?vue&type=template&id=42a5d76c"
import script from "./Prizes.vue?vue&type=script&lang=js"
export * from "./Prizes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__